module.exports = __webpack_public_path__ + "static/media/project-value.bf301ed7.svg";